import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Country } from '../../models/country';

@Injectable()
export class CountryService {
  private _countries: ReplaySubject<Country[]> = new ReplaySubject<Country[]>();
  public countries$: Observable<Country[]> = this._countries.asObservable();

  constructor(private _http: HttpClient) {
    this._http.get(environment.countryUrl).subscribe(data => {
      this._countries.next(
        (data as Country[]).sort((a: Country, b: Country) => {
          // sort the countries!
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        })
      );
    });
  }
}
